import { createFileRoute } from "@tanstack/react-router";
import FounderMoneyball from "@/pages/FounderMoneyball";

export const Route = createFileRoute("/accelerator/moneyball/")({
  component: FounderMoneyball,
});
